import CandidateResume from './CandidateResume.container';

export default CandidateResume;
